jQuery(document).ready(function($) {

/*---------------------------------------------------------------------------*
 * Scroll to top
/*---------------------------------------------------------------------------*/
	$('.top').click(function() {
		$('html, body').animate({scrollTop:0},'slow');
		return false;
	});

/*---------------------------------------------------------------------------*
 * Menu fade
/*---------------------------------------------------------------------------*/
	$('.nav ul.children').hide();
	$('.nav li').hover( 
		function() {
			$(this).children('ul.children').slideDown('fast');
		}, 
		function() {
			$(this).children('ul.children').hide();
		}
	);
	
/*---------------------------------------------------------------------------*
 * Show/Hide Category List
/*---------------------------------------------------------------------------*/
	if($('.category-expand').length) {
		$('.format-icon').hover(
			function() {
				$(this).children('.category-expand').animate({width:'toggle'},'fast');
			},
			function() {
				$(this).children('.category-expand').hide();
			}
		);
	}
});